import mutate from 'js-core/js/apollo/mutations/mutate';
import invalidateQuery from 'js-core/js/apollo/mutations/invalidateQuery';

import CreateParcelMutation from 'gql/mutations/Parcel/CreateParcel.gql';
import UpdateParcelMutation from 'gql/mutations/Parcel/UpdateParcel.gql';
import DeleteParcelMutation from 'gql/mutations/Parcel/DeleteParcel.gql';

export default class{

    static create(input) {

        return mutate(CreateParcelMutation, { input }, store => {

            invalidateQuery(store, 'allParcels');
        });
    }

    static update(input) {

        return mutate(UpdateParcelMutation, { input });
    }

    static delete(id) {

        return mutate(DeleteParcelMutation, { id }, store => {

            invalidateQuery(store, 'allParcels');
        });
    }
}
